// Shared syntax-marker shape for the live syntax-error passes.
//
// Two producers emit this shape: the MSSQL ANTLR∧tree-sitter collector
// (`collectSyntaxMarkers.ts`, `code: 'tsql-syntax'`) and the tree-sitter-only
// per-engine collector (`collectTreeSitterSyntaxMarkers.ts`, `code:
// '<engine>-syntax'`). The Monaco layer (`SqlMonaco.tsx`) converts the returned
// UTF-16 offsets to positions via `model.getPositionAt`, so this module never
// touches Monaco and never re-derives line/column.

/** Monaco marker `code` — namespaced per engine so it never collides with LSP
 *  codes and each engine's pass owns its own marker `owner`. */
export type SyntaxMarkerCode =
  | 'tsql-syntax'
  | 'mysql-syntax'
  | 'oracle-syntax'
  | 'sqlite-syntax';

/** Runtime companion to `SyntaxMarkerCode`. Consumers that must recognise a
 *  syntax marker at run time — the `fix-keyword-typo` code action gates on the
 *  marker `code` before reading its message — import this instead of re-typing
 *  the literals. */
export const SYNTAX_MARKER_CODES: readonly SyntaxMarkerCode[] = [
  'tsql-syntax',
  'mysql-syntax',
  'oracle-syntax',
  'sqlite-syntax',
];

export type SyntaxMarker = {
  /** Absolute UTF-16 code-unit offsets into the document source. */
  readonly startOffset: number;
  readonly endOffset: number;
  readonly message: string;
  readonly code: SyntaxMarkerCode;
};
